import { Height } from "@mui/icons-material";
import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import Image from "next/image";

const CustomerBrandDealerNear = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  paddingLeft: "8%",
  paddingRight: "8%",
  marginTop: "48px",
  paddingTop: "12px",
  ".vehicles-grid-container": {
    padding: "0",
    display: "flex",
    justifyContent: "flex-start",
  },
  ".promiseHeader": {
    fontSize: "24px",
    fontWeight: "700",
    letterSpacing: "0em",
    textAlign: "left",
  },
  ".location_img": {
    width: "100%",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
    marginTop: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    ".promiseHeader": {
      fontSize: "24px",
      marginTop: "24px",
    },
  },
  ".promiseHeader": {
    fontSize: "24px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "10px",
    marginTop: "24px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0 24px",
    ".promiseHeader": {
      fontSize: "24px",
    },
    ".content-text": {
      fontSize: "12px",
    },
    ".location_img": {
      height: "100px",
    },
  },
}));
const BrandDealerNear = ({ BannerDealerData }) => {
  return (
    <>
      <CustomerBrandDealerNear>
        <Grid
          container
          spacing={3}
          className="vehicles-grid-container"
          id="search-result"
        >
          <Grid item>
            <Typography
              variant="h2"
              className="promiseHeader"
              sx={{
                fontSize: { xs: "24px", md: "24px" },
                fontWeight: "700 !important",
                textAlign: "start !important",
              }}
            >
              {BannerDealerData?.headerInfo}
            </Typography>
          </Grid>
          <Grid item xs={12} lg={12}>
            <Image
              src={BannerDealerData?.desktopImg}
              width={3010}
              height={300}
              className="location_img"
              alt="electric auto dealers near me"
              visibleByDefault={true}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="p" className="content-text">
              {BannerDealerData?.description ??
                `At Turno we provide you with the best prices on electric commercial
          vehicles. We are committed to providing affordable financing options
          for goods electric vehicles to individuals as well as small and
          mid-sized businesses. With a team of EV experts, Turno leads the
          industry of electric goods auto in India.`}
            </Typography>
          </Grid>
        </Grid>
      </CustomerBrandDealerNear>
    </>
  );
};

const MemoizedBrandDealerNear = React.memo(BrandDealerNear);
export default MemoizedBrandDealerNear;
